import { getTagTreesData, queryFormDetail, createForms, updateForms } from "@/views/zhiji/js/services/service.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import { genIndexSearchHandler, sceneTree2Selector } from "@/views/zhiji/js/common/util.js";
import formWidgetManager from "./widgets/formWidgetManager.js";
import i18n from "@/i18n";

export default {
    state: {
        sceneClassDatas: [],
        searchSceneClassDatas: [],
        formInfo: {
            content: [],
            formType: "0",
            autoContents: [],
            curRespChannel: ["1", "2"]
        },
        isFirstCreate: false,
        isActiveSaveBtn: false,
        saveBtnValue: "1" // "1"保存 "2"已保存
    },
    mutations: {
        updateCreateState(state, data) {
            state.isFirstCreate = data.isFirstCreate;
        },
        updataSaveBtnStatus(state) {
            let formInfo = state.formInfo;
            let channelCheck = formInfo.curRespChannel.length > 0;
            if (
                formInfo.name &&
                formInfo.name != "" &&
                formInfo.tagId &&
                formInfo.tagId != "def" &&
                formInfo.title &&
                formInfo.title != "" &&
                state.saveBtnValue === "1"
            ) {
                formInfo.formType != "2"
                    ? (state.isActiveSaveBtn = true)
                    : channelCheck
                    ? (state.isActiveSaveBtn = true)
                    : (state.isActiveSaveBtn = false);
            } else {
                state.isActiveSaveBtn = false;
            }
        },
        editFormsClearModule(state, data) {
            state.saveBtnValue = "1";
            state.sceneClassDatas.splice(0);
            state.searchSceneClassDatas.splice(0);
            state.formInfo = {
                content: [],
                formType: "0",
                autoContents: [],
                curRespChannel: ["1", "2"]
            };
            data && data.tagId
                ? Object.assign(state.formInfo, {
                      tagId: data.tagId
                  })
                : "";
            this.commit("zhiji/updataSaveBtnStatus");
        },
        updateEditScene(state, datas) {
            state.sceneClassDatas.splice(0, state.sceneClassDatas.length, ...datas);
            state.searchSceneClassDatas.splice(0, state.searchSceneClassDatas.length, ...datas);
        },
        searchFormScenes(state, data) {
            let searchDatas = [];
            state.searchSceneClassDatas.forEach(item => {
                if (item.label.indexOf(data.field) != -1) {
                    searchDatas.push(item);
                }
            });
            data.field != "" ? (state.sceneClassDatas = searchDatas) : (state.sceneClassDatas = state.searchSceneClassDatas);
        },
        updateFormInfo(state, formDetail) {
            state.formInfo = Object.assign(state.formInfo, formDetail);
            this.commit("zhiji/updataSaveBtnStatus");
        },
        editFormContents(state, data) {
            formUpdata(state.formInfo, data);
        },
        updateAutoContents(state, data) {
            state.formInfo.autoContents = data;
        }
    },
    actions: {
        initFormEditor(context, param) {
            getTagTreesData()
                .then(function(treeData) {
                    const sceneData = sceneTree2Selector(treeData);
                    context.commit("updateEditScene", sceneData);
                })
                .catch(err => showMessage(err, context));

            param.formId &&
                queryFormDetail(param)
                    .then(formDetail => {
                        context.commit("updateFormInfo", formDetail);
                    })
                    .catch(err => showMessage(err, context));
        },
        saveFormEditor(context) {
            let formInfo = context.state.formInfo;
            new Promise(function(resolve) {
                checkFormValidate(context.state);
                resolve();
            })
                .then(function() {
                    return context.state.isFirstCreate
                        ? createForms(formInfo).then(() => {
                              context.state.saveBtnValue = "2";
                              context.commit("updataSaveBtnStatus");
                          })
                        : updateForms(formInfo).then(() => {
                              context.commit("editFormsClearModule");
                              context.dispatch("hideModal", {
                                  type: "FormEditModal",
                                  data: {}
                              });
                              context.dispatch("queryFormList");
                          });
                })
                .catch(err => {
                    context.state.saveBtnValue = "1";
                    context.commit("updataSaveBtnStatus");
                    showMessage(err, context);
                });
        }
    }
};

// 表单修改总入口
function formUpdata(editForm, data) {
    const handlers = {
        addFormContent: formContentAdd,
        deleteFormContent: formContentDelete,
        updateFormContent: formContentUpdate,
        transferFormContent: formContentTransfer
    };

    handlers[data.type].call(null, editForm, data);
}

// 表单组件增加widget
function formContentAdd(editForm, data) {
    const widgetHandler = formWidgetManager.clientMap[data.wtType];

    widgetHandler && editForm.content.push(widgetHandler.initContent());
}

// 表单组件删除widget
function formContentDelete(editForm, data) {
    deleteItemByUId(editForm.content, data.widget);
}

// 表单组件修改widget
function formContentUpdate(editForm, data) {
    updateItemByUId(editForm.content, data.widget);
}

// 表单组件移动widget
function formContentTransfer(editForm, data) {
    transItemByUId(editForm.content, data.widget);
}

// 删除或更改元素状态抽象函数 uId, updateState
function deleteItemByUId(items, newItem) {
    let itemIdx = genIndexSearchHandler("uId")(items, newItem.uId);
    let item = items[itemIdx];

    if (item.updateState == "add") {
        items.splice(itemIdx, 1);
    } else {
        item.updateState = "delete";
    }
}

// 更新并且更改元素状态抽象函数 uId, updateState
function updateItemByUId(items, newItem) {
    let itemIdx = genIndexSearchHandler("uId")(items, newItem.uId);
    let item = items[itemIdx];

    if (item.updateState !== "add") {
        item.updateState = "update";
    }

    let updatedItem = Object.assign({}, item, newItem);
    items.splice(itemIdx, 1, updatedItem);
}

// 更新并且更改元素状态抽象函数 uId, updateState
function transItemByUId(items, param) {
    const itemIdx = genIndexSearchHandler("uId")(items, param.uId);
    const item = items[itemIdx];

    if (param.newIdx < 0 || param.newIdx === itemIdx) {
        return;
    }

    items.splice(itemIdx, 1);
    items.splice(param.newIdx, 0, item);
}

function showMessage(err, context) {
    if (err.errorType == "ParamError" || err.errorType == "ServerRespError") {
        context.commit("showModal", {
            type: "messageModal",
            data: {
                type: "error",
                message: err.message
            }
        });

        return true;
    } else {
        console.error(err);
    }
}

function checkFormValidate(state) {
    let content = state.formInfo.content;
    if (content && content.length > 0) {
        checkFormContent(state.formInfo.content);
    } else {
        throw new ParamError(i18n.t("zhiji.form.pleaseAddComponent"));
    }

    let formType = state.formInfo.formType;
    if (formType === "2") {
        let autoContents = state.formInfo.autoContents;
        checkAutoContents(autoContents);
    }
}

function checkAutoContents(contents) {
    let check = contents.some(item => !item.content);
    if (check || contents.length === 0) {
        throw new ParamError(i18n.t("zhiji.form.autoErrorTip"));
    }
}

function checkFormContent(contents) {
    contents.forEach(function(content) {
        const widgetHandler = formWidgetManager.clientMap[content.wtType];

        if (content.updateState != "" && content.updateState != "delete" && widgetHandler) {
            widgetHandler.checkContent.call(null, content);
        }
    });
}
